/**
 * Liaise wordmark — canonical SVGs from the brand kit (in /public).
 * Variant 'white' (default) for navy/dark backgrounds; 'navy' for light backgrounds.
 */
export default function LiaiseWordmark({
  className,
  variant = "white",
}: {
  className?: string;
  variant?: "white" | "navy" | "strapline-white";
}) {
  const src =
    variant === "navy"
      ? "/liaise-logo-navy.svg"
      : variant === "strapline-white"
        ? "/liaise-logo-strapline-white.svg"
        : "/liaise-logo-white.svg";
  return <img src={src} alt="Liaise" className={className} />;
}
